<template>
    <div class="home-container col-87 relative">
        <Header :proName='proName' :wxPhone="wxPhone"></Header>
        <div class="home-type flex">
            <TypeList :deviceInfo='deviceInfo' version="horiz"></TypeList> 
        </div>
        <div class="home-times flex">
            <div class="font-24">总监测次数：</div>
            <div class="font-34 font-bold" v-for="(item,key) in monitorNum" :key="key">
                <p>{{item}}</p>
            </div>
        </div>
        <div class="ui-content">
            <div class="ui-flex">
                <div class="ui-swiper">
                    <div class="home-hd hd-equip flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">客户信息</div>
                    </div>
                    <div class="relative">
                        <div class="ui-flex font-20">
                            <div class="flex-1 text-c">客户名</div> 
                            <div class="flex-1 text-c">安装位置</div>
                            <div class="flex-1 text-c">饮用水流量(L)</div>
                            <div class="flex-1 text-c">净水TDS(mg/L)</div>
                        </div>
                        <div class="mar-t1 col-87">
                            <div v-if="filteredDevList.length>10"> 
                                <div @click="toHozPage($event)">
                                    <Scroll class="table-warp" :dataList="filteredDevList" type='pro-list' @getMore='getMore'>
                                        <div slot="list" class="table-item">
                                            <div class="ui-dev-list ui-flex flex-ac mar-t2 cur-p" v-for="(item,key) in filteredDevList" :key="key" :data-index="key">
                                                <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.projectShortName?item.projectShortName:item.projectName}}</div></div>
                                                <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.projectAddr}}</div></div>
                                                <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.latestWeekOutWater||'-'}}</div></div>
                                                <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.avgPurTds}}</div></div>
                                            </div>
                                        </div>
                                    </Scroll>
                                </div>
                                
                            </div> 
                            <div v-else> 
                                <div>
                                    <div @click="toHozPage($event)" class="ui-dev-list ui-flex flex-ac mar-t2 cur-p" v-for="(item,key) in filteredDevList" :key="key" :data-index="key">
                                        <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.projectShortName?item.projectShortName:item.projectName}}</div></div>
                                        <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.projectAddr}}</div></div>
                                        <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.latestWeekOutWater||'-'}}</div></div>
                                        <div class="flex-1 text-c font-14"><div class="ui-dev-1">{{item.avgPurTds}}</div></div>
                                    </div>
                                </div>
                            </div> 
                        </div> 
                    </div> 
                </div>
                <div class="mar-l4">
                    <div class="home-hd hd-water flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">饮用水流量(周)</div>
                    </div>
                    <div class="hd-equip-c">
                        <BrokenLine :userWaterList='userWaterList' :waterStatus='waterStatus' version="horiz"></BrokenLine>
                    </div>
                </div>
            </div>

            <div class="ui-flex">
                <div class="flex-1">
                    <div class="home-hd flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">服务情况</div>
                    </div>
                    <div class="hd-server">
                        <div class="ui-flex font-20">
                            <div class="flex-1 text-c">客户名</div>
                            <div class="flex-1 text-c">机器位置</div>
                            <div class="flex-1 text-c">工单进度</div>
                            <div class="flex-1 text-c">操作时间</div>
                        </div>
                        <div class="mar-t1" v-if="serviceStatus">
                            <div v-if="recentList.length>0">
                                <RencList :recentList='maskedRecentList' pageType='home' :recentInfo='{}' version='horiz'></RencList>
                            </div> 
                        </div> 
                    </div>
                </div>
                <div class="flex-1 mar-l4">
                    <div class="home-hd flex">
                        <img class="h-title" src="../assets/images/h-title.png" alt="">
                        <div class="font-26 mar-l1 font-bold">饮水量(月)</div>
                    </div> 
                    <div class="hd-server">
                        <LineBarHome :lineList='lineList' :serviceNumStatus='serviceNumStatus' version="horiz"></LineBarHome>
                    </div>
                </div>
            </div>
            
        </div>
    </div> 
</template>

<script> 
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
import Header from '@/components/Header'
import Scroll from "@/components/Scroll";
import BrokenLine from '@/components/BrokenLine'
import MicLine from '@/components/MicLine' 
import RencList from '@/components/RencList'
import LineBarHome from '@/components/LineBarHome'
import HorizlBar from '@/components/HorizlBar' 
import TypeList from '@/components/TypeList'
import NoneData from '@/components/NoneData.vue'
export default { 
    components:{
        Header,
        swiper,
        swiperSlide,
        BrokenLine,
        RencList,
        MicLine,
        LineBarHome,
        HorizlBar,
        TypeList,
        Scroll,
        NoneData
    },  
    computed: { 
        mySwiper() {
            // mySwiper 是要绑定到标签中的ref属性  
            return this.$refs.mySwiper.swiper
        },
        filteredDevList() {
            return this.devList.filter(item => !this.isExcludedCustomer(item));
        },
        maskedRecentList() {
            return this.recentList.map(item => Object.assign({}, item, {
                projectName: this.maskSensitiveName(item.projectName)
            }));
        }
    },
    filters:{
        purFilter(value,_ty){  
            let totalPurWaterNum,
            totalPurWaterNumUnit='L';
            if(value && value.toString().length>0){
                totalPurWaterNum = Math.round(value/1000);
                totalPurWaterNumUnit='L';
                if(totalPurWaterNum.toString().length>3){
                    totalPurWaterNum = parseFloat(totalPurWaterNum/1000).toFixed(2);
                    totalPurWaterNumUnit='t';
                    if(parseInt(totalPurWaterNum).toString().length>4){
                        totalPurWaterNum = parseFloat(totalPurWaterNum/10000).toFixed(2);
                        totalPurWaterNumUnit='万t';
                    }
                } 
                if(_ty == 'tds'){
                    return totalPurWaterNum;
                } else {
                    return totalPurWaterNumUnit;
                }
            }   
        }
    },
    data(){
        return {  
            waterStatus:false,//用水趋势
            userWaterList:[],//用水趋势
            proName:'',
            projectCode:'',//P0001000455
            wxPhone:'',
            serviceStatus:false,
            recentList:[],
            serviceNumStatus: false,//服务人数
            lineList:[],
            deviceInfo:[],
            kindGarInfo:{},
            devList:[],//设备列表 
            monitorList:[],  
            filterListPro:[], 
            monitorNum:'', 
            totalPurWaterNum:'',
            purTds:'',
            timer:null,
            queryParams: {}, 
            offLineList:[],
            serviceDownStatus:false,
            offLineInfo:{},
            onLineList:[],
            serviceUpStatus:false,
            onLineInfo:{},
        }
    }, 
    methods: {
        getCustomerName(item) {
            return item.projectShortName || item.projectName || '';
        },
        isExcludedCustomer(item) {
            const name = this.getCustomerName(item).toString();
            const nameLower = name.toLowerCase();
            return name.includes('冯宇光') || name.includes('清渟') || nameLower.includes('qt');
        },
        maskSensitiveName(name) {
            if (!name) return '';
            let result = name.toString();
            [['冯宇光', false], ['清渟', false], ['qt', true]].forEach(([keyword, caseInsensitive]) => {
                const mask = '*'.repeat(keyword.length);
                if (caseInsensitive) {
                    const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    result = result.replace(new RegExp(escaped, 'gi'), mask);
                } else {
                    result = result.split(keyword).join(mask);
                }
            });
            return result;
        },
        // 免密登录
        toMLogin(_this){  
            let params ={
                'phone':_this.wxPhone,
                'withoutCode':1,//免密登录为1，其他为0
            }
            // 免密登录
            _this.$api.reqLogin(params).then(res=>{
                if(res.success){   
                    let user=res.data;  
                    localStorage.setItem('user',JSON.stringify(user))  
                    this.toBurialPoint(user.phone)// 埋点  
                    setTimeout(()=>{
                        if(user.customerLevel != 0){//项目级  
                            this._initData(); 
                        }
                    },200)    
                }  
            }) 
        }, 
        _initData() { 
            let user=JSON.parse(localStorage.getItem('user')) 
            this.loginPhone = user.phone; 
            const { customerLevel,bindCode,provinceCode,areaCode,cityCode,provinceName,cityName,areaName }=user
            let code="",level="",location=""
            if(customerLevel==4|| customerLevel==5){//国家
                code = '';
                level = 'country';
                location="中国"
            }else if(customerLevel==3){//省
                code = provinceCode;
                level = 'province';
                location=provinceName  
            }else if(customerLevel==2){//市
                code = cityCode;
                level = 'city'; 
                location=cityName 
            }else if(customerLevel==1){//区
                code = areaCode;
                level = 'area'; 
                location=areaName 
            } 
            this.queryParams.code= code
            this.queryParams.level= level 
            this.queryParams.bindCode= bindCode 
            localStorage.setItem('locParams',JSON.stringify(this.queryParams));
            this.initPage(); 
        },
        initPage() {  
            Promise.all([this.checkProNum(this),this.initOnlineInfo(this),this.initOffOnlineInfo(this),this.initServiceInfo(this),
            this.initWaterUserInfo(this),this.initTdsInfo(this),this.initWaterUseInfo(this),this.initPeoSumInfo(this)]).then(res=>{ 
            }) 
        }, 
        // 项目信息
        initProBaseInfo(_this){  
            _this.$api.reqGetProBaseInfo(this.queryParams).then(res=>{
                if(res.success){ 
                    _this.kindGarInfo.totalNum = res.data.totalNum; 
                    let list;
                    if(res.data && res.data.projectBaseInfoList){
                        res.data.projectBaseInfoList.map(item=>{
                            item.latestWeekOutWater = Math.round(item.latestWeekOutWater/1000)
                            item.projectWarningInfoList = item.projectWarningInfoList.length>0?true:false;
                        })
                        list = res.data.projectBaseInfoList;  
                    } 
                    if(_this.queryParams.pageNum==1){
                        _this.devList = list;   
                    } else { 
                        if(list.length<10 && _this.queryParams.pageNum!=1){
                            _this.queryParams.pageNum = 1;
                            _this.queryParams.startColumnNum = 0;
                            _this.initProBaseInfo(_this) 
                        } else {  
                            _this.devList = _this.devList.concat(list);  
                        }
                    }
                }  
            })
        },
        // 净水TDS
        initTdsInfo(_this){
            _this.$api.reqQualityByDistrict(this.queryParams).then(res=>{
                if(res.success){   
                    this.deviceInfo.push({
                        name:'净水TDS均值',
                        icon: require("../assets/images/home-5.png"),
                        unit: "mg/L",
                        value:res.data.purTds?res.data.purTds:0,
                        class:'pro-4'
                    })
                    this.queryParams.pageNum = 1;
                    this.queryParams.pageSize=20;
                    this.queryParams.startColumnNum = 0;
                    this.initProBaseInfo(this); 
                } 
            })
        },
        // 设备总数，服务总人数
        initPeoSumInfo(_this){ 
            _this.$api.reqGetProProNum(_this.queryParams).then(res=>{
                if(res.success){
                    let totalEquipNum,
                    totalEquipNumUnit,
                    totalSupplyWaterNum,
                    totalSupplyWaterNumUnit;
                    if(res.data && res.data.totalSupplyWaterNum){
                        if(res.data.totalSupplyWaterNum.toString().length>4){
                            totalSupplyWaterNum = parseFloat(res.data.totalSupplyWaterNum/10000).toFixed(2); 
                            totalSupplyWaterNumUnit='万人';
                            if(parseInt(totalSupplyWaterNum).toString().length>3){
                                totalSupplyWaterNum = parseFloat(totalSupplyWaterNum/1000).toFixed(2);
                                totalSupplyWaterNumUnit='千万人'; 
                            }
                        } else {
                            totalSupplyWaterNum = res.data.totalSupplyWaterNum;
                            totalSupplyWaterNumUnit='人';
                        }
                        
                    }  
                    if(res.data.totalEquipNum.toString().length>4){
                        totalEquipNum = parseFloat(res.data.totalEquipNum/10000).toFixed(3); 
                        totalEquipNumUnit='万台';
                        if(parseInt(totalEquipNum).toString().length>3){
                            totalEquipNum = parseFloat(totalEquipNum/1000).toFixed(3);
                            totalEquipNumUnit='千万台'; 
                        }
                    } else {
                        totalEquipNum = res.data.totalEquipNum;
                        totalEquipNumUnit='台';
                    }
                    _this.deviceInfo.push({
                        name:'机器总数',
                        icon: require("../assets/images/home-3.png"),
                        unit: totalEquipNumUnit,
                        value:res.data && res.data.totalEquipNum?totalEquipNum:0,
                        class:'pro-3'
                    }) 
                    
                    _this.deviceInfo.push({ 
                        name:"可供人总数",
                        value:res.data && res.data.totalSupplyWaterNum?totalSupplyWaterNum:0, 
                        icon:require('../assets/images/home-2.png'),
                        unit:totalSupplyWaterNumUnit,
                        class:'pro-2'
                    }) 
                    _this.initWaterInfo(this);    
                }   
            })
        },
        // 用水情况服务人数
        initWaterUserInfo(_this){ 
            _this.$api.reqGetWaterUserInfo(_this.queryParams).then(res=>{
                if(res.success){  
                    _this.serviceNumStatus = true;
                    _this.lineList = res.data;
                } 
            })
        },
        // 线上服务
        initOnlineInfo(_this){ 
            _this.$api.reqGetOnlineInfo(_this.queryParams).then(res=>{
                if(res.success){
                    _this.serviceUpStatus = true;
                    _this.onLineInfo = res.data;
                    _this.onLineList = res.data.onlineServiceDetailVoList; 
                }   
            })
        },
        // 线下服务 
        initOffOnlineInfo(_this){ 
            _this.$api.reqGetOffOnlineInfo(_this.queryParams).then(res=>{
                if(res.success){
                    _this.serviceDownStatus = true;
                    _this.offLineInfo = res.data; 
                    _this.offLineList = res.data.offlineServiceDetailVoList;
                }   
            })
        },
        // 总饮水量
        initWaterInfo(_this){ 
            _this.$api.reqWaterFlowMonitor(_this.queryParams).then(res=>{
                if(res.success){
                    let totalOutFlow,
                    totalOutFlowUnit;  
                    if(res.data.totalOutFlow.toString().length>0){
                        totalOutFlow = Math.round(res.data.totalOutFlow/1000);
                        totalOutFlowUnit='L';
                        if(totalOutFlow.toString().length>3){
                            totalOutFlow = Math.round(totalOutFlow/1000);
                            totalOutFlowUnit='t';
                            if(totalOutFlow.toString().length>4){
                            totalOutFlow = Math.round(totalOutFlow/10000);
                            totalOutFlowUnit='万t';
                            }
                        } 
                    }   
                    _this.deviceInfo.push({
                        name:'饮用水总量',
                        icon: require("../assets/images/home-6.png"),
                        unit: totalOutFlowUnit,
                        value:totalOutFlow?totalOutFlow:0,
                        class:'pro-5'
                    }) 
                }   
            })
        },
        // 近期服务 
        initServiceInfo(_this){ 
            _this.queryParams.pageNum = 1;
            _this.queryParams.pageSize = 10;
            _this.queryParams.startColumnNum = 0; 
            _this.$api.reqGetServiceInfo(this.queryParams).then(res=>{
                if(res.success){
                    _this.serviceStatus = true;
                    _this.recentInfo = res.data;
                    _this.recentList = res.data.orderInfoVoList;
                    _this.recentList.map(item=>{ 
                        item.addrs = [];  
                        if(item.equipInfoVoList && item.equipInfoVoList.length>0){ 
                        for(let i = 0;i<item.equipInfoVoList.length;i++){  
                            item.addrs.push(item.equipInfoVoList[i].equipPlace)
                        }  
                        } else {
                        if(item.equipPlace){
                            item.addrs.push(item.equipPlace)
                        }
                        } 
                        item.addrs = item.addrs.join();    
                    })
                }  
            })
        },
        // 查询监测次数
        checkProNum(_this){
            _this.$api.reqGetRegionMonitorNum(_this.queryParams).then(res=>{ 
                if(res.success){ 
                    res.data && res.data.upDataNum
                    ? (_this.monitorNum = res.data.upDataNum.toString())
                    : (_this.monitorNum = "0");
                } 
            })
        },
        // 埋点
        toBurialPoint(phone,projectCode){
            this.$api.reqBurialPoint({
                uuid:phone,//
                url:this.$router.path, //当前事件触发页面的url
                bak1:'login-tender-A',//login -- 登录 logout --登出 
                clientType:'brows',//app 浏览器
                bak2:projectCode
            }).then(res=>{ 
                if(res.success){ 
                }else{
                    this.toast(res.message)
                }
            })
        }, 
        // 用水趋势
        initWaterUseInfo(_this){
            _this.$api.reqWaterUserInfo(_this.queryParams).then(res=>{
                if(res.success){  
                    _this.waterStatus = true;
                    _this.userWaterList = res.data;
                } 
            })
        },   
        getMore() {
            let pageTotal = Math.ceil(this.kindGarInfo.totalNum / 20) // 最大页数  
            if (this.queryParams.pageNum < pageTotal) {
                // 现有总数小于所有总数
                this.queryParams.pageNum++
                this.queryParams.startColumnNum = this.queryParams.pageSize*(this.queryParams.pageNum-1);  
            } else if (this.queryParams.pageNum == pageTotal) {
                this.queryParams.pageNum = 1;
                this.queryParams.startColumnNum = 0; 
            } 
            this.initProBaseInfo(this)  
        }, 
        // 跳转项目首页
        toHozPage(e){
            let items = e.target.closest(".ui-dev-list");//防止复制的事件不能点击
            let item;   
            if(items){ 
                item = this.filteredDevList[items.dataset.index] 
                let params = JSON.parse(JSON.stringify(item));
                params.projectAddress = params.projectAddr; 
                localStorage.setItem('proDevMsg',JSON.stringify(params))
                this.$router.push(`/prohome?projectCode=`+item.projectCode+`&projectName=`+(item.projectShortName?item.projectShortName:item.projectName))
            }   
        },
    },
    mounted(){
        if(this.$route.query.loginParamCode){
            this.wxPhone = this.$route.query.loginParamCode;
            this.toMLogin(this)
        } 
    },
    created(){           
    },
    destroyed(){    
    }
}
</script>

<style lang="scss" scoped>  
    .home-type{
        position: absolute;
        top: 0;
        right: 0;
        width: 35rem;
        height: 5rem;  
    }
    .home-times{
        margin-left: 4.375rem;
    }
    .ui-line{
        width: .625rem;
        height: 100%;
        background: #87CEFA;
    }
    .h-normal{
        width: 6.75rem;
        height: 6.75rem;
    }

    .ui-swiper{
        width: 100%;
        height: 29.7375rem;  
        overflow: hidden; 
        .swiper-wrap{ 
            text-align: left;
            width: 100%;
        }
    } 
    .ui-swiper1{
        width: 80%;
        margin-top: 3.75rem; 
        height: 9.75rem;  
        overflow: hidden;
        &::-webkit-scrollbar{
            display: none;
        }
    }
    .ui-content{
        padding: 0 30px;
        margin-top: 10px;
        .home-hd{
            height: 3.8125rem;
            line-height: 3.8125rem;
            padding: 0 1.75rem;
            background: linear-gradient(90deg, rgba(63,187,254,0.2) 0%, rgba(65,119,255,0.2) 100%); 
        } 
        .hd-equip{
            width: 62.9375rem; 
        }
        .hd-equip-c{
            height: 23.4375rem; 
            padding: 20px; 
            .hd-equip-l{
                width: 24.25rem;
                .hd-equip-addr{
                    height: 6.25rem;
                    line-height: 6.25rem; 
                }
                .h-warn{   
                    img{
                        width: 2.5rem;
                        height: 2.5rem;
                    }
                }
            } 
        }
        .hd-equip-r{
            width: 60%; 
            height: 100%;
            position: absolute;
            z-index: 999;
            top: 0; 
            right: 0; 
            .equip-filter{
                width: 100%;
                height: 14.125rem;
                .filter-list{
                    height:8.7375rem;  
                }
            }
            .equip-mic{
                width: 100%; 
                .mic-list{
                    height:6.7375rem; 
                }
            }
        } 
        .hd-water{ 
            width: 43.3125rem; 
        }
        .hd-server{
            height: 22.5rem; 
            padding: 20px;
            overflow: hidden; 
        }
    } 
</style>



// WEBPACK FOOTER //
// src/page/Home.vue